<template>
  <div class="translation"
       v-if="epigram && epigram.versions">
<!--
    <div
      @click="onFrenchMuteClick"
      v-if="epigram.sounds.french"
      class="mute french-mute"
    >
      <span class="glyphicon glyphicon-volume-up"></span>
    </div>
-->

    <div class="text-title">
      <h2>
        <span class="bg"></span>
        {{ epigram.title }}

      </h2>
    </div>

    <div class="text-lang">
      <label class="text-lang__label" for="selectLanguage">Langue : </label>
      <div class="text-lang__select-wrap">
        <select v-model="selectedLanguage" id="selectLanguage">
          <option disabled value="">Sélectionnez une langue…</option>
          <option
            v-for="language in availableVersions"
            v-bind:value="language"
          >
            {{ language.family }}
            ({{ language.name }})
          </option>
        </select>
      </div>
    </div>

    <div class="text-container-top-gradient"></div>
    <div class="text-container">

      <div class="text-content">
        <p v-html="customLanguageSelect(epigram.versions).text_translated"></p>
      </div>
      <div class="text-author">
        <div v-for="author in authors">
          <span class="dash"></span>
          <p><router-link :to="{ name: 'authorSingle', params: { id: author.versions[0].id_author} }">{{ customLanguageSelect(author.versions).name }}</router-link></p>
        </div>
        <div v-if="!authors.length">
          <span class="dash"></span>
        </div>
      </div>
    </div>

    <div class="text-container-bottom-gradient"></div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  props: {
    epigram: {},
    parcoursTitle: '',
    selectedLanguage: {},
    authors: [],
    languages: []
  },
  computed: {
    availableVersions: function () {
      var self = this
      var returnVersions = []

      if (self.epigram) {
        self.epigram.versions.forEach(function (version) {
          for (var i = 0; i < global.languages.length; i++) {
            if (global.languages[i].id_language === version.id_language) {
              returnVersions.push(global.languages[i])
            }
          }
        })
      }

      return returnVersions
    }
  },
  created () {
    var self = this

    self.languages = global.languages

    // Set the language
    self.setCustomLanguage(self.parseVersion(self.epigram.versions).id_language)
  },
  methods: {
    versionLanguage (versions, options) {
      return global.versionLanguage(versions, options)
    },
    parseVersion (versions) {
      return global.parseVersion(versions)
    },
    customLanguageSelect (versions) {
      var self = this

      if (self.selectedLanguage) {
        for (var i = 0; i < versions.length; i++) {
          if (versions[i].id_language === self.selectedLanguage.id_language) {
            return versions[i]
          }
        }
        // if we got here, we didn't return yet, so default to parseVersion method
        return self.parseVersion(versions)
      } else {
        // fall back to global parseVersion if not set
        return self.parseVersion(versions)
      }
    },
    setCustomLanguage (languageId) {
      var self = this
      for (var i = 0; i < self.availableVersions.length; i++) {
        if (self.availableVersions[i] === languageId) {
          self.selectedLanguage = self.availableVersions[i]
        }
      }
    },
    onFrenchMuteClick: function () {
      var controlBtn, playBtn, frenchSound, greekSound, greekMute
      var frenchMute = $('.french-mute .glyphicon')
      controlBtn = $('.control')
      playBtn = controlBtn.children('.play-button')
      frenchSound = $('audio')[0]
      greekSound = $('audio')[1]
      greekMute = $('.greek-mute .glyphicon')
      greekMute.removeClass('glyphicon-volume-off').addClass('glyphicon-volume-up')
      if (greekSound.currentTime > 0) {
        greekSound.pause()
        greekSound.currentTime = 0
        greekSound.volume = 1
      }
      if (frenchSound.paused) {
        frenchSound.play()
        controlBtn
          .removeClass('greek-sound-playing')
          .addClass('french-sound-playing')
        playBtn.removeClass('paused')
      } else {
        if (frenchSound.volume === 1) {
          frenchSound.volume = 0
          frenchMute.removeClass('glyphicon-volume-up').addClass('glyphicon-volume-off')
        } else {
          frenchSound.volume = 1
          frenchMute.removeClass('glyphicon-volume-off').addClass('glyphicon-volume-up')
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
$raleway: 'Raleway', Helvetica, Arial, sans-serif

.translation

  .text-theme,
  .text-title
    text-align: center

    span.bg
      left: -0.5em
      height: 1.5em
      widht: 1.5em

    h2,
    h3,
      font-family: $raleway
      font-weight: 600
      color: #5e5e5e

  .text-title
    margin-bottom: 10px

    h2
      font-size: 12px
      position: relative
      display: inline-block

  .text-lang
    margin-left: 10%
    display: flex
    flex-direction: row
    align-items: flex-start
    font-size: 10px
    text-transform: uppercase
    font-family: $raleway
    font-weight: 600

  .text-lang__label
    margin-right: 1em

  .text-lang__select-wrap
    // note width and background x-position (145px vs 135px)
    background: url('/static/img/select-arrow.png') no-repeat 135px center
    width: 145px
    overflow: hidden

    select
      font-weight: 300
      color: #5e5e5e
      border: none
      color: #2c2c2c
      background: transparent
      outline: none
      &:focus
        outline: 1px dotted #fff
        option
          outline: 1px dotted #fff


      option
        width: 160px // overflow container, hide native arrow

  .text-container-top-gradient
    display: block
    width: 100%
    position: absolute
    background: linear-gradient(0deg, rgba(255,255,255,0), rgba(255,255,255,1) 50%)
    height: 20px
    z-index: 29
  .text-container-bottom-gradient
    display: block
    width: 100%
    position: absolute
    background: linear-gradient(180deg, rgba(255,255,255,0), rgba(255,255,255,1) 50%)
    height: 30px
    z-index: 29
    margin-top: -30px

  // text-container contains text + author
  .text-container
    margin: 0 auto
    min-height: 33vh
    max-height: 40vh
    overflow-y: scroll
    position: relative
    padding: 25px 0 25px 10% // compensate for gradients

    .text-content
      // width: 300px
      // height: 300px
      scrollbar-face-color: #2c2c2c
      scrollbar-track-color: #fff
      scrollbar-arrow-color: #fff

      &:hover
        &::-webkit-scrollbar-thumb,
        &::-webkit-scrollbar-track
          visibility: visible

      &::-webkit-scrollbar
        background: #fff
        width: 3px

      &::-webkit-scrollbar-button
        display: none

      &::-webkit-scrollbar-thumb
        background: rgba(44, 44, 44, .3)
        visibility: hidden

        &:hover
          background: rgba(44, 44, 44, .8)

        &:active
          background: rgba(44, 44, 44, 1)

      &::-webkit-scrollbar-track
        border-bottom: 1px solid #2c2c2c
        border-top: 1px solid #2c2c2c
        visibility: hidden

      p
        font-size: 14px
        color: #2c2c2c
        line-height: 1.5em
        margin-bottom: 20px

        &::first-letter
          font-size: 36px

  .text-author
    margin-top: 20px

    .dash
      width: 10px
      height: 1px
      margin-right: 10px
      margin-top: 8px

    p
      display: inline-block
      margin: 0
      font-style: italic
      font-size: 14px
      color: #2c2c2c
      font-family: "Times New Roman", sans-serif
</style>



// WEBPACK FOOTER //
// Translation.vue?1d39bbeb